import React, { FunctionComponent } from 'react';
import HeaderImage from '../../assets/img/opa-congressional-outreach-header.png';

const CongressionalOutreachHeader: FunctionComponent<{ subtitle: string }> = ({ subtitle }) => {
  return (
    <header className="outreachHeaderImageContainer">
      <img src={HeaderImage} alt="Congressional Outreach" className="outreachHeaderImage" />
      <div className="outreachHeaderDiv">
        <h1 className="outreachHeaderTitle">Congressional Outreach</h1>
        <p data-cy="base-title-in-header" className="outreachHeaderSubtitle">
          {subtitle}
        </p>
      </div>
    </header>
  );
};

export default CongressionalOutreachHeader;
